import { FunctionComponent, useEffect } from 'react';

// GlobalStyles is now a no-op component as all global styles are in _tailwind.css
// This component is kept for backwards compatibility
export const GlobalStyles: FunctionComponent = () => {
  useEffect(() => {
    // Add soho-font class dynamically if needed
    const style = document.createElement('style');
    style.textContent = `
      @font-face {
        font-family: 'Playfair Display';
        src: local('Playfair Display'),
          url('https://d2nw8b1k8diib7.cloudfront.net/general/fonts/playfair_display.woff2') format('woff2');
        font-display: auto;
        font-style: normal;
        font-stretch: normal;
      }
      .soho-font {
        font-family: 'Playfair Display';
      }
      .gu-mirror {
        display: none !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return null;
};
